class BaseSchema {
  constructor(name, version, namespace, data) {
    this.name = name;
    this.version = version;
    this.namespace = namespace;

    if (!this.getData) {
      throw new Error("You must implement getData to use the base schema.");
    }

    this.data = this.getData(data);
  }
}

export default BaseSchema;



// WEBPACK FOOTER //
// ./client/app/common/clickstream/schemas/base-schema.js